/**
 * @namespace Broadcastinfo
 * @aka SWR.Broadcastinfo
 */
SWR.Broadcastinfo = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'broadcastinfo';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.teaser-broadcast .broadcastinfo, aside.broadcastinfo'
  };

  var broadcastHTML = '' +
    '    <meta itemprop="startDate" content="{startDate}">' +
    '    <dl>' +
    '        <dt>Sendung am</dt>' +
    '        <dd data-date="broadcastDate">' +
    '            <time datetime="{startDate}">' +
    '                <span class="broadcastDay">{day}</span>' +
    '                <span>{time} Uhr</span>' +
    '            </time>' +
    '        </dd>' +
    '        <dd>' +
    '            {info}' +
    '        </dd>' +
    '    </dl>'

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Broadcastinfo = function () {

    function Broadcastinfo(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.now = SWR.Util.getNow();
      self.isTeaser = (self.$element.closest('.teaser-broadcast').length > 0);
      self.isSegment = self.$element.closest('.teaser-broadcast').data("segmentId") === "true";

      self.broadcastFurther = self.$element.siblings().filter(function () {
        return $(this).hasClass('broadcastfurther');
      });

      self._getDate();

      if (self.broadcastFurther.length !== 0) {
        self._checkFurther();
        self._getDate();

        //Alle zukünftigen Sendetermine werden umformatiert:
        self._reformatFurther();
      }

      self._checkDate(self.date);
    }

    /******
     * Diese Funktion sucht aus dem HTML das Datum der Sendeinformation heraus.
     * Sofern es sich um eine Sendeinformation unter einem Artikel oder in einem
     * Liveblog-Eintrag handelt, werden Start- und Enddatum ermittelt.
     * @private
     */
    Broadcastinfo.prototype._getDate = function _getDate() {
      var self = this;

      if (self.isTeaser) {
        //Wenn Element ein Teaser ist:
        self.date = new Date(self.$element.find('time').attr('content'));
      } else {
        //Wenn Element ein Aside unter Artikel/im Liveblog-Eintrag ist:
        self.date = new Date(self.$element.find('meta[itemprop="startDate"]').attr('content'));
        self.endDate = new Date(self.$element.find('meta[itemprop="endDate"]').attr('content'));
      }
    };

    /******
     * Diese Funktion prüft, ob das ermittelte (Start-)Datum
     * - in der Vergangenheit
     * - heute
     * - morgen
     * - in der Zukunft
     * liegt.
     *
     * Anschließend wird mit dieser Information die Ersetzung der Sendungsinformationen
     * begonnen.
     *
     * @param date            ein übergebenes Date-Objekt
     * @param furtherElement  wenn es ein weiterer Sendungstermin ist, wird hier das Element übergeben
     * @private
     */
    Broadcastinfo.prototype._checkDate = function _checkDate(date, furtherElement = null) {
      var self = this;
      var pastTodayTomorrowFuture = 3;

      if (SWR.Util.dateIsInPast(date, self.now)) {
        pastTodayTomorrowFuture = -1;
      } else if (SWR.Util.dateIsSameDay(date, self.now)) {
        pastTodayTomorrowFuture = 0;
      } else if (SWR.Util.dateIsTomorrow(date, self.now)) {
        pastTodayTomorrowFuture = 1;
      } else if (SWR.Util.dateIsDayAfterTomorrowOrGreater(date, self.now)) {
        pastTodayTomorrowFuture = 2;
      }

      if (pastTodayTomorrowFuture !== 3) {
        self._setText(pastTodayTomorrowFuture, furtherElement);
      }
    };

    /******
     * Diese Funktion ersetzt bestimmte Teile der Sendungsinformation
     * durch neue Texte.
     * Beispielsweise wird das Datum durch das Wort "heute" ersetzt,
     * wenn es am heutigen Tag liegt.
     *
     * @param pastTodayTomorrowFuture  die ermittelte Zahl aus der gleichnamigen Funktion
     * @param furtherElement  wenn es ein weiterer Sendungstermin ist, wird hier das Element übergeben
     * @private
     */
    Broadcastinfo.prototype._setText = function _setText(pastTodayTomorrowFuture, furtherElement = null) {
      var self = this;
      var sendungPrefix = "Sendung am";
      var dayString = "";

      switch (pastTodayTomorrowFuture) {
        case -1:
          sendungPrefix = self.isSegment ? "aus der Sendung vom" : "Sendung vom";
          break;
        case 0:
          sendungPrefix = self.isSegment ? "in der Sendung von" : "Sendung von ";
          dayString = "heute";
          break;
        case 1:
          sendungPrefix = self.isSegment ? "in der Sendung von" : "Sendung von ";
          dayString = "morgen";
          break;
        case 2:
          sendungPrefix = self.isSegment ? "in der Sendung vom" : "Sendung am ";
          break;
      }

      if(furtherElement){
        //Wenn es sich um einen Termin aus den weiteren Sendeterminen handelt:
        if (dayString !== "") {
          furtherElement.find('.broadcastDay').empty().text(dayString);
        }
      } else {
        //Wenn es sich NICHT um einen Termin aus den weiteren Sendeterminen handelt:
        if (self.isTeaser && pastTodayTomorrowFuture > -1) {
          if (dayString !== "") {
            //Wenn es sich um einen Teaser handelt und das
            //Sendungsdatum heute oder morgen ist, wird das Datum
            //durch das Wort ersetzt.
            self.$element.find('.date').empty().text(dayString);
          }
        } else if (self.isTeaser && pastTodayTomorrowFuture === -1) {
          //Wenn das Sendungsdatum bereits in der Vergangenheit liegt,
          //wird es aus dem Teaser entfernt.
          self.$element.remove();
        }

        if (!self.isTeaser) {
          //Wenn es kein Teaser ist, werden die entsprechenden
          //Texte ins HTML geschrieben.
          self.$element.find('dt').empty().text(sendungPrefix);
          if (dayString !== "") {
            self.$element.find('.broadcastDay').empty().text(dayString);
          }
        }
      }
    };

    /******
     * Diese Funktion wird aufgerufen, wenn es weitere Sendetermine auf der Seite gibt.
     * Wenn das Sendedatum unter "Sendung am" bereits vorbei ist, wird in den
     * weiteren Sendeterminen der nächste Termin gesucht und an diese Stelle geschrieben.
     *
     * Sind die weiteren Sendetermine bereits vorbei, werden sie gelöscht.
     *
     * Beispiel:
     * Unter einem Artikel steht:
     * Sendung vom
     *     Do, 14.7.2016 3.40 Uhr SWR Fernsehen
     *
     * Weitere Sendetermine
     *     Sa, 16.7.2016 23.20 Uhr SWR Fernsehen
     *
     * Fall 1:
     * Wir haben den 15.7.2016.
     *
     * Der obere Eintrag (Do, 14.7.2016) wird durch den unteren (Sa, 16.7.2016) ersetzt.
     *
     * Fall 2:
     * Wir haben den 17.7.2016.
     *
     * Der obere Eintrag (Do, 14.7.2016) bleibt stehen und der untere (Sa, 16.7.2016) wird gelöscht.
     *
     * @private
     */
    Broadcastinfo.prototype._checkFurther = function _checkFurther() {
      var self = this;
      var nextFound = false;

      //Wenn EndDate erreicht ist
      if (self.endDate.getTime() < self.now.getTime()) {
        // Nächsten Sendetermin finden und den aktuellen Sendetermin durch den nächsten ersetzen
        for (var i = 0; i < self.broadcastFurther.length; i++) {
          var currentFurtherElement = $(self.broadcastFurther[i]);

          currentFurtherElement.find('dd[data-date="broadcastDate"]').each(function () {
            var currentItem = $(this);
            var currentDate = new Date(currentItem.find('time').attr('datetime'));

            if (currentDate.getTime() < self.now.getTime()) {
              //Weitere Sendetermine, die bereits abgelaufen sind, werden entfernt
              currentItem.remove();
            } else {
              //Wenn der nächste Sendetermin gefunden ist, der noch in der Zukunft liegt,
              //wird die aktuelle Sendeinformation durch die neue ersetzt.
              if (!nextFound) {
                self.$element.html(COMMON.Utils.template(broadcastHTML, {
                  startDate: currentDate.toISOString(),
                  day: currentItem.find('.broadcastDay').html(),
                  time: currentItem.find('.broadcastDay + span').text(),
                  info: currentItem.find('.broadcastDay + span + span').text()
                }));
                nextFound = true;
                currentItem.remove();
              }
            }
          });

          //Wenn keine zukünftigen Termine übrig bleiben, wird auch der Container gelöscht
          if (currentFurtherElement.find('dd[data-date="broadcastDate"]').length === 0) {
            currentFurtherElement.remove();
          }
        }
      }
    };

    /******
     * Diese Funktion wird aufgerufen, wenn es weitere Sendetermine auf der Seite gibt.
     * Jeder einzelne dieser Termine soll neu formatiert werden.
     * @private
     */
    Broadcastinfo.prototype._reformatFurther = function _reformatFurther() {
      var self = this;

      for (var i = 0; i < self.broadcastFurther.length; i++) {
        var currentFurtherElement = $(self.broadcastFurther[i]);

        currentFurtherElement.find('dd[data-date="broadcastDate"]').each(function () {
          var currentItem = $(this);
          var currentDate = new Date(currentItem.find('time').attr('datetime'));

          self._checkDate(currentDate, currentItem);
        });
      }
    };

    // public
    Broadcastinfo.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);
      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Broadcastinfo._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Broadcastinfo(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Broadcastinfo;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Broadcastinfo._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Broadcastinfo._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Broadcastinfo._jQueryInterface;
  $.fn[NAME].Constructor = Broadcastinfo;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Broadcastinfo._jQueryInterface;
  };

  return Broadcastinfo;

})(window.jQuery);
